<template>
  <div class="jackpot__item" :class="{ 'jackpot__item--big': big }">
    <div class="jackpot__item-title">
      <u-i-compressed-image
        v-if="level.image"
        loading="lazy"
        class="jackpot__item-icon"
        :compressed-images="level.image"
      />
      <span>{{ level.name }}</span>
    </div>
    <animated-number class="jackpot__item-value" :value="level.amount" :currency="currencyCode" :max="0" />
  </div>
</template>

<script setup>
import AnimatedNumber from 'components/layouts/AnimatedNumber.vue'
import { useSiteInfoStore } from 'src/stores/site-info'
import UICompressedImage from 'components/ui/UICompressedImage.vue'

defineProps({
  id: {
    type: Number,
    default: () => 1,
  },
  level: {
    type: Object,
    default: () => {},
  },
  big: {
    type: Boolean,
    default: () => false,
  },
})
const currencyCode = useSiteInfoStore().userCurrency?.code || useSiteInfoStore().defaultCurrency?.code || 'USD'
</script>

<style lang="scss" scoped>
.jackpot__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.07);
  border-radius: 4px;

  &-icon {
    width: 16px;
    height: 16px;
  }

  &--big {
    @include tab {
      padding: 16px;
      backdrop-filter: blur(8px);
    }
    @include desktop {
      width: calc(33% - 6px);
    }
  }

  &-title {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.7);
    font-weight: 500;
    font-size: 12px;
    gap: 4px;
  }

  &-value {
    font-size: 16px;
    font-weight: 800;
    color: rgba(255, 255, 255, 0.9);
  }
}
</style>
